import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SearchFacetAccordionItem } from '#/modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from '#/modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from '#/modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { SEARCH_COMMON_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchCommonRefinementTypes';
import { useSearchFacetSelectedValues } from '#/modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { LOCATION_TYPE_CHECKBOX_OPTIONS } from '#/utils/constants/general/locationType';

type Props = {
  variant: SearchRefinementVariant;
};

export function LocationTypeFacet({ variant }: Props) {
  const { i18n } = useI18n();
  const selectedFacetValues = useSearchFacetSelectedValues('locationType');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="locationType"
      icon="desk"
      label={
        <>
          {SEARCH_COMMON_REFINEMENT_LABELS(i18n).locationType}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="locationType"
        initialValue={selectedFacetValues}
        options={LOCATION_TYPE_CHECKBOX_OPTIONS(i18n)}
      />
    </FacetVariant>
  );
}
